 
<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getMaterialPurchaseByWildSearch(0,10)" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getMaterialPurchaseByWildSearch(0,10)"></i>
                  </div>
  
                  <button *ngIf="actionControls.isAdd" title="Add" (click)="addP()" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
 
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                
                      <th style="width: 20%;">{{ 'material-purchase.invoiceNo' | translate }}</th>
                      <th style="width: 20%;">{{ 'material-purchase.invoiceDate' | translate }}</th>
                      <th style="width: 20%;">{{ 'material-purchase.branchName' | translate }}</th>
                      <th style="width: 15%;">{{ 'material-purchase.vendorName' | translate }}</th>
                      <th style="width: 15%;">{{ 'material-purchase.latestStatus' | translate }}</th>
                      <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let material of materials | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 20%;">{{material.invoiceNo}}</p>
                      <p style="width: 20%;"><span *ngIf="material.invoiceDate != 0 && material.invoiceDate != null">{{material.invoiceDate | date}}</span> <span *ngIf="material.invoiceDate == 0 || material.invoiceDate == null">--</span></p>            
                      <p style="width: 20%;">{{material.branchName}}</p>            
                      <p style="width: 15%;">{{material.vendorName}}</p>            
                      <p style="width: 15%;">{{material.latestStatus}}</p>            
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i *ngIf="actionControls.isView" (click)="getMaterialById(material.materialPurchaseId)"  data-toggle="modal" data-target="#viewModal" class="bi bi-eye-fill"></i>
                      </p>                
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && materials.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
  
        </div>
    </div>
</div>
  
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'material-purchase.headings.add' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
            <div class="form-group">
              <div class="row">
                <div class="col-md-6 col-lg-6">
                    <label>{{ 'material-purchase.invoiceNo' | translate }} <span class="star-mark">*</span></label>
                    <input formControlName="invoiceNo" type="text" class="form-control">
                </div>
                <div class="col-md-6 col-lg-6">
                    <label>{{ 'material-purchase.invoiceDate' | translate }} <span class="star-mark">*</span></label>
                    <input formControlName="invoiceDate" type="date" class="form-control">
                </div>
                <div class="col-md-6 col-lg-6">
                    <label>{{ 'material-purchase.branchName' | translate }} <span class="star-mark">*</span></label>
                    <select class="form-control" formControlName="branchName">
                      <option *ngFor="let a of branch" [value]="a.name">{{a.name}}</option>
                    </select>
                </div>
                <div class="col-md-6 col-lg-6">
                  <label>{{ 'material-purchase.vendorName' | translate }} <span class="star-mark">*</span></label>
                  <select class="form-control" formControlName="vendorName">
                    <option *ngFor="let b of vendor" [value]="b.name">{{b.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                    <div *ngFor="let item of prod;let i = index;let itemLast = last;">
                      <div class="productList" >
                        <div class="row">
                          <div class="col-md-6 col-lg-6">
                            <div class="product-name-list">
                              <input type="text" class="form-control" placeholder="search product" (keyup)="getAllByWildSearchWithoutPagination(i)" [(ngModel)]="prod[i].productName" [ngModelOptions]="{standalone: true}">
                              <div class="product-list" *ngIf="prod[i].productList.length != 0">
                                <p *ngFor="let product of prod[i].productList" (click)="selectProductName(product,i,product.name,product.supportedUOM,product.version)">{{product.name}}</p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <select class="form-control" (change)="uomChange(i)" [ngModelOptions]="{standalone: true}"  [(ngModel)]="prod[i].uomName" >
                              <option value="" disabled selected hidden>---select uom name---</option>
                              <option *ngFor="let uom of prod[i].uomList" [value]="uom.uomName">{{uom.uomName}}</option>
                            </select>
                          </div>
                        </div>
                        <div *ngIf="getProductVersion(prod[i].productName,i) != 1">
                          <div class="infoObj" *ngFor="let infoObj of item.infoObj;let j = index;let last = last">
                            <input type="number" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter slNo" [(ngModel)]="prod[i].infoObj[j].slNo">
                            <input type="text" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter make" [(ngModel)]="prod[i].infoObj[j].make">
                            <input type="text" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter model" [(ngModel)]="prod[i].infoObj[j].modal">
                            <input type="date" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter expiry date" [(ngModel)]="prod[i].infoObj[j].expiryDate">
  
                            <svg xmlns="http://www.w3.org/2000/svg" *ngIf="last" (click)="addi(i)" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" (click)="removeinfoObj(i,j)" *ngIf="!last" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                            </svg>
                          </div>
                        </div>

                        <div *ngIf="getProductVersion(prod[i].productName,i) == 1">
                          <div class="infoObj">
                            <input type="number" style="width: 100%;" class="form-control" [ngModelOptions]="{standalone: true}" placeholder="enter quantity" [(ngModel)]="prod[i].quantity">
                          </div>
                        </div>

                        <div class="row" *ngIf="item.warranty">

                          <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                              <label for="">{{ 'material-purchase.purchaseDate' | translate }}</label>
                              <input class="form-control" type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="prod[i].warrantyInfo.purchaseDate">
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6">
                            <div class="form-group">
                              <label for="">{{ 'material-purchase.expirationDate' | translate }}</label>
                              <input class="form-control" type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="prod[i].warrantyInfo.expirationDate">
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-6" *ngFor="let keyValues of item.warrantyInfo.keyValues;let j = index;let last = last">
                            <div class="form-group">
                              <label for="">{{keyValues.key}}</label>
                              <input class="form-control" type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="prod[i].warrantyInfo.keyValues[j].value">
                            </div>
                          </div>
                        </div>
                        
                      </div>
                      <div class="add-remove" *ngIf="!itemLast" style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
                        <button (click)="removeProd(i)">{{ 'generic.remove' | translate }}</button>
                      </div>
                      <div class="add-remove" *ngIf="itemLast" style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
                        <button *ngIf="i!=0" (click)="removeProd(i)">{{ 'generic.remove' | translate }}</button>
                        <button (click)="addP()" style="margin-left: 10px;">{{ 'generic.add' | translate }}</button>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="modal-footer">
                <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                <button type="button" (click)="addMaterial()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
              </div>
            </div>
        </div>
  </div>
  </div>
  </div>
</div>


<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'material-purchase.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div *ngFor="let viewData of viewData">
            <div class="">
              <div class="row">
                  <div class="col-md-3 col-lg-3 details">
                      <label>{{ 'material-purchase.invoiceNo' | translate }}</label>
                      <p>{{viewData.invoiceNo}}</p>
                  </div>
                  <div class="col-md-3 col-lg-3 details">
                      <label>{{ 'material-purchase.invoiceDate' | translate }}</label>
                      <p *ngIf="viewData.invoiceDate != 0 && viewData.invoiceDate != null">{{viewData.invoiceDate | date}}</p>
                      <p *ngIf="viewData.invoiceDate == 0 || viewData.invoiceDate == null">--</p>
                  </div>
                  <div class="col-md-3 col-lg-3 details">
                      <label>{{ 'material-purchase.branchName' | translate }}</label>
                      <p>{{viewData.branchName}}</p>
                  </div>
                  <div class="col-md-3 col-lg-3 details">
                    <label>{{ 'material-purchase.vendorName' | translate }}</label>
                    <p>{{viewData.vendorName}}</p>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                    <div *ngFor="let item of viewProd;let i = index;let itemLast = last;">
                      <div class="productList" >
                        <div class="row">
                          <div class="col-md-4 col-lg-4 details details1">
                            <label for="">{{ 'material-purchase.productName' | translate }}</label>
                            <p>{{item.productName}}</p>
                          </div>
                          <div class="col-md-4 col-lg-4 details details1">
                            <label for="">{{ 'material-purchase.uomName' | translate }}</label>
                            <p>{{item.uomName}}</p>
                          </div>
                          <div class="col-md-4 col-lg-4 details details1">
                            <label for="">{{ 'material-purchase.quantity' | translate }}</label>
                            <p>{{item.quantity}}</p>
                          </div>
                        </div>
                     
                        <div class="table-info">
                          <table class="table table-striped" *ngIf="item.infoObj.length != 0 && item.infoObj != null">
                            <thead>
                              <tr>
                                <th style="width: 25%;text-align: center;">{{ 'material-purchase.slNo' | translate }}</th>
                                <th style="width: 25%;text-align: center;">{{ 'material-purchase.make' | translate }}</th>
                                <th style="width: 25%;text-align: center;">{{ 'material-purchase.modal' | translate }}</th>
                                <th style="width: 25%;text-align: center;">{{ 'material-purchase.expiryDate' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let infoObj of item.infoObj;let j = index;let last = last">
                                <td style="width: 25%;text-align: center;">{{infoObj.slNo || " -- "}}</td>
                                <td style="width: 25%;text-align: center;">{{infoObj.make || " -- "}}</td>
                                <td style="width: 25%;text-align: center;">{{infoObj.modal || " -- "}}</td>
                                <td style="width: 25%;text-align: center;" ><span *ngIf="infoObj.expiryDate != 0 && infoObj.expiryDate != null">{{infoObj.expiryDate | date}}</span> <span *ngIf="infoObj.expiryDate == 0 || infoObj.expiryDate == null"> -- </span></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        
        <div class="status-table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 30%;text-align: center;">{{ 'material-purchase.userId' | translate }}</th>
                  <th style="width: 30%;text-align: center;">{{ 'material-purchase.purchaseTransferStatus' | translate }}</th>
                  <th style="width: 40%;text-align: center;">{{ 'material-purchase.updatedDate' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of viewstatus; let i = index;let itemLast = last;">
                  <td style="width: 30%;text-align: center">{{status.userId}}</td>
                  <td style="width: 30%;text-align: center;">{{status.purchaseTransferStatus}}</td>
                  <td style="width: 40%;text-align: center;" >
                    <span *ngIf="status.updatedDate != 0 && status.updatedDate != null">{{status.updatedDate | date:'medium'}}</span> <span *ngIf="status.updatedDate == 0 || status.updatedDate == null">--</span></td>
                </tr>
                
              </tbody>
            </table>
        </div>
         
        <div class="modal-footer" *ngFor="let viewData of viewData">
          <button type="button" (click)="rejectPurchase()" *ngIf="viewData.latestStatus == 'ENTER'" style="float: left;" class="btn btn-danger left" >{{ 'generic.reject' | translate }}</button>
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button *ngIf="viewData.latestStatus == 'ENTER'" (click)="approvePurchase()" type="button"   class="btn btn-primary">{{ 'generic.approve' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
